<template>
    <li class="categories-list__item">
        <!-- <a :href="product_link"> -->
        <router-link :to="toSubCategoryLink(product_link)" v-if="hasDSVEH != 'Y'">
            <div class="image image--type--category">
                <div class="image__body">
                    <img class="image__tag" :src="image_path" alt="">
                </div>
            </div>
            <div class="categories-list__item-name">{{name}}</div>
        </router-link>
        <a href="javascript:void(0)" v-else @click.prevent="$emit('kitDialog', category_code)">
            <div class="image image--type--category">
                <div class="image__body">
                    <img class="image__tag" :src="image_path" alt="">
                </div>
            </div>
            <div class="categories-list__item-name">{{name}}</div>
        </a>
        <div class="categories-list__item-products" v-if="total_products > 0">{{total_products}} products</div>
    </li>
    <li class="categories-list__divider"></li>    
</template>

<script>
import CloudinaryApi from '../../../utilities/cloudinaryapi';
import * as GCONST from '../../../constants.js';

export default {
    props: [
        'index', 'name', 'total_products', 'product_link', 'subcat', 'img_category_id', 'hasDSVEH', 'category_code'
    ],

    data() {
        return {
            image_path: '',
        }
    },

    methods: {
        toSubCategoryLink(uri) {
            // console.log(uri);
            if(uri != '')
                return '/category/1/' + uri;
                // return '/category-search/' + uri;
            else
                return '/category';
        }
    },
    created() {
        const clApi = new CloudinaryApi;
        clApi.category_id = this.img_category_id;
        // console.log(this.name + ' = ' + this.img_category_id);
        
        clApi.vlImageByMeta(GCONST.CL_META_CATEGORY_ID, GCONST.Category).then(imgURL => {
            // console.log('imgURL = ' + imgURL);
            if(imgURL){
                this.image_path = imgURL;
            }else{
                this.image_path = GCONST.IMAGE_PLACEHOLDER;
            }
        });
    }
}
</script>